import { createApi } from "../../utils/createApi";
import { AxiosResponse, AxiosError } from "axios";
import { IntegrationSelectionScreen } from "./IntegrationSelectionScreen";
import { StatusNotificationScreen } from "../../common/StatusNotificationScreen";
import {
  OnboardingProgressDiv,
  isCameraCheckSupported,
} from "../Onboarding/OnboardingProgressDiv";
import { cameraRefreshCheck } from "./cameraRefreshCheck";
import { handleAddImmixToAddCameraForm } from "./handleAddImmixToAddCameraForm";
import { handleAddDiceToAddCameraForm } from "./handleAddDiceToAddCameraForm";
import { universalAPIErrorHandler } from "../../utils/universalAPIErrorHandler";
import { logger } from "../../../utils/logger";

export const fetchAddCameraInfo = async (
  id: number,
  setVisibleScreen: any,
  navigate: any
) => {
  const AxiosUI = createApi("");
  const retryFunction = () => {
    fetchAddCameraInfo(id, setVisibleScreen, navigate);
  };

  // ONVIF over WireGuard: skip NVR auto-add / manual camera entry — cameras are
  // added later from the progress screen via Discover Cameras.
  if (localStorage.selectedIntegrationName === "onvif_wireguard") {
    setVisibleScreen(
      <OnboardingProgressDiv
        percentage={33}
        step={1}
        setVisibleScreen={setVisibleScreen}
      />
    );
    return;
  }

  if (localStorage.autoAdd === "true") {
    cameraRefreshCheck(setVisibleScreen, navigate);
  } else {
    await AxiosUI.get(`customer/${id}/camera_onboarding_forms/`).then(
      (response: AxiosResponse) => {
        // handleAddImmixToAddCameraForm(response.data);
        // handleAddDiceToAddCameraForm(response.data);
        localStorage.setItem("addCameraInfo", JSON.stringify(response.data));
        localStorage.setItem(
          "selectedProducts",
          JSON.stringify(response.data.initial_data.products)
        );
        setVisibleScreen(
          <StatusNotificationScreen
            styling="absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80"
            text="Site created successfully!"
          />
        );
        setTimeout(() => {
          setVisibleScreen(
            <OnboardingProgressDiv
              percentage={
                isCameraCheckSupported()
                  ? localStorage.healthMonitoringOnly === "true"
                    ? 33
                    : 25
                  : 33
              }
              step={1}
              setVisibleScreen={setVisibleScreen}
            />
          );
        }, 2000);
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          logger.log(`Error: ${reason}`);
          setVisibleScreen(
            <IntegrationSelectionScreen setVisibleScreen={setVisibleScreen} />
          );
        });
      }
    );
  }
};
